<template>
  <article class="shadow bg-white px-1 py-5 rounded">
    <edit-campaign v-if="isOpenFormEditingCampaign" :open="isOpenFormEditingCampaign" :campaign="campaign" @close="closeFormEditingCampaign" />

    <div>
      <header class="campaign-header">
        <div>
          <h2 class="font-bold" @click="listBadgeOpened = !listBadgeOpened">{{ campaign.name[lang] }}</h2>
          <div class="mt-2">
            <span class="px-2 py-1 text-xs rounded bg-yellow-200 border border-yellow-200 text-gray-700" v-if="nbTesting > 0">{{ nbTesting }} {{ $t('campaign.state.testing') }}</span>
            <span class="px-2 py-1 text-xs rounded bg-green-500 border border-green-500 text-white" v-if="nbPublished > 0">{{ nbPublished }} {{ $t('campaign.state.published') }}</span>
            <span class="px-2 py-1 text-xs rounded bg-gray-200 border border-gray-200 text-gray-700" v-if="nbTerminated > 0">{{ nbTerminated }} {{ $t('campaign.state.terminated') }}</span>
            <span class="px-2 py-1 text-xs rounded border border-gray-300 text-gray-500 cursor-pointer" v-if="nbTesting > 0 || nbPublished > 0 || nbTerminated > 0" @click="listBadgeOpened = !listBadgeOpened">{{ textToggleBadges }}</span>
            <span class="px-2 py-1 text-xs rounded border border-gray-300 text-gray-500 cursor-pointer" v-if="isAuthorizedCreateBadge" @click="toggleCreateBadge">{{ $t('badge.actions.add') }}</span>
            <span class="px-2 py-1 text-xs rounded border border-gray-300 text-gray-500 cursor-pointer" v-if="isAuthorizedCreateBadge && copiedBadge" @click="pasteCopiedBadge">Paste badge</span>
          </div>
          <span class="period" v-if="campaign.activationdate">{{ campaign.activationdate | date }} - {{ campaign.deactivationdate | date }}</span>
        </div>
        <div class="actions">
          <k-dropdown>
            <template slot="handler">
              <font-awesome-icon icon="ellipsis-v"></font-awesome-icon>
            </template>
            <k-dropdown-option @click.native="isOpenFormEditingCampaign = true">Edit</k-dropdown-option>
            <k-dropdown-option @click.native="publishAll">Publish All</k-dropdown-option>
            <k-dropdown-option @click.native="deleteCampaign">Delete</k-dropdown-option>
          </k-dropdown>
        </div>
      </header>
    </div>

    <create-badge v-if="modal.createBadge" :idCampaign="campaign.id" @close="closeCreateBadge"/>
    <badge-list v-show="listBadgeOpened" :badges="badges" :campaign="campaign"/>
    <button type="button" class="add-badge-prompt" v-if="isAuthorizedCreateBadge && promptNewBadge"  @click="toggleCreateBadge">
      <font-awesome-icon icon="plus"></font-awesome-icon>
      {{ $t('badge.actions.add-new') }}
    </button>
  </article>
</template>

<script>
import CreateBadge from './../badges/FormBadge.vue'
import BadgeList from './../badges/BadgeList.vue'
import EditCampaign from './FormCampaign.vue'
import dropdown from '@/components/dropdown.vue'
import moment from 'moment'

import { mapGetters, mapActions } from 'vuex'

export default {
  components: { BadgeList, EditCampaign, CreateBadge, dropdown },
  props: {
    campaign: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      listBadgeOpened: false,
      /**
       * Edition
       */
      isOpenFormEditingCampaign: false,
      promptNewBadge: false,

      modal: {
        editcampaign: false,
        createBadge: false
      }
    }
  },
  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),

    textToggleBadges () {
      return !this.listBadgeOpened ? this.$t('badge.actions.see') : this.$t('badge.actions.hide')
    },

    isAuthorizedCreateBadge () {
      if (this.campaign.deactivationdate) {
        let activationdate = moment(this.campaign.deactivationdate)
        let diff = moment().diff(activationdate, 'secondes')
        if (diff > 0) {
          return false
        }
      }
      return true
    },
    nbTesting () {
      return this.getNbByStatus('testing')
    },
    nbPublished () {
      return this.getNbByStatus('published')
    },
    nbTerminated () {
      return this.getNbByStatus('terminated')
    },
    badges () {
      return this.badgesFiltered(this.campaign)
    },
    ...mapGetters('badges', {
      badgesFiltered: 'getByCampaign',
      copiedBadge: 'copiedBadge'
    }),

    getNbAchievement () {
      var nb = 0
      for (var i = 0; i < this.badges.length; i++) {
        nb += this.badges[i].children.length + 1
      }
      return nb
    }
  },
  methods: {
    /**
     * Edition
     */
    closeFormEditingCampaign () {
      this.closeDropdown()

      this.isOpenFormEditingCampaign = false
    },
    pasteCopiedBadge () {
      const badge = this.copiedBadge
      badge.category = {}
      badge.category.id = this.campaign.id
      this.pasteBadge(badge)
        .then(() => {
          this.$notify({title: 'Success', message: this.$root.$t('notifications.badge.pasted')})
        })
        .catch(() => {
          this.$notify.error({title: 'Error', message: this.$root.$t('notifications.unknown')})
        })
    },

    getNbByStatus (status) {
      var nb = 0
      for (var i = 0; i < this.badges.length; i++) {
        if (this.badges[i].status === status) {
          nb++
        }

        if (this.badges[i].children) {
          for (var d = 0; d < this.badges[i].children.length; d++) {
            if (this.badges[i].children[d].status === status) {
              nb++
            }
          }
        }
      }

      return nb
    },
    toggleCreateBadge () {
      this.closeDropdown()

      this.modal.createBadge = !this.modal.createBadge
    },
    closeCreateBadge (badge) {
      this.closeDropdown()

      if (badge) {
        this.listBadgeOpened = true
        // prompt to create new badge
        this.promptNewBadge = true
        setTimeout(() => {
          this.promptNewBadge = false
        }, 5000)

        setTimeout(() => {
          let element = document.getElementById('badge-' + badge.id)
          if (this.$SmoothScroll) {
            this.$SmoothScroll(element, 800)
          }
        }, 200)
      }
      this.modal.createBadge = false
    },

    publishAll () {
      let incompleteBadges = []
      let totalBadgesUpdated = 0

      // Loop over all badges
      this.badges.forEach((badge) => {
        // Loop over children and check they can be published
        if (badge.children) {
          badge.children.forEach(child => {
            if (child.status !== 'published') {
              totalBadgesUpdated++
              if (!this.badgeIsUnlockable(child)) {
                incompleteBadges.push(child.name.fr)
              }
            }
          })
        }

        if (badge.status !== 'published') {
          badge.status = 'published'
          totalBadgesUpdated++
          if (!this.badgeIsUnlockable(badge)) {
            incompleteBadges.push(badge.name.fr)
          }
          // Update badge and increase total badges updated counter
          this.updateBadge({ badge, sitekey: this.$route.params.site })
            .catch(e => {
              this.$notify.error({ title: 'Error', message: this.$root.$t('notifications.unknown') })
            })
        }
      }) // end loop

      if (totalBadgesUpdated > 0) {
        this.$notify({ title: 'Success', message: `${totalBadgesUpdated}  ${this.$root.$t('badge.state.publishedAll')}` })
      }
      if (incompleteBadges.length) {
        setTimeout(() => {
          this.$notify({ title: 'Warning', message: `${this.$root.$t('badge.state.blockedWarning')} ${incompleteBadges.join(', ')} )` })
        }, 1000)
      }
    },

    badgeHasEvent (badge) {
      if (badge.events.length > 0) {
        return true
      }
      return false
    },

    badgeHasChild (badge) {
      if (badge.children.length > 0) {
        return true
      }
      return false
    },

    badgeIsChild (badge) {
      if (badge.parent && badge.parent.id) {
        return true
      }
      return false
    },

    badgeIsParent (badge) {
      return !this.badgeIsChild(badge)
    },

    badgeIsUnlockable (badge) {
      if (this.badgeIsParent(badge) && this.badgeHasChild(badge)) {
        for (var i = 0; i < badge.children.length; i++) {
          if (badge.children[i].events.length === 0) {
            return false
          }
        }
        return true
      } else if (this.badgeIsParent(badge) && this.badgeHasEvent(badge)) {
        return true
      } else if (this.badgeIsChild(badge) && this.badgeHasEvent(badge)) {
        return true
      }
      return false
    },

    toggleCampaign () {
      this.closeDropdown()

      this.visible.newcampaign = !this.visible.newcampaign
    },

    ...mapActions('campaigns', ['removeCampaign']),

    deleteCampaign () {
      this.closeDropdown()

      this.removeCampaign({ campaign: this.campaign, sitekey: this.$route.params.site })
        .then(() => {
          this.$notify({ title: 'Success', message: this.$root.$t('notifications.campaign.deleted'), type: 'success' })
        })
        .catch((e) => {
          this.$notify.error({ title: 'Error', message: this.$root.$t('notifications.unknown') })
        })
    },
    closeDropdown () {
      this.openMoreAction = false
    },
    ...mapActions('modals', ['toggle']),
    ...mapActions('badges', ['updateBadge', 'pasteBadge']),
    ...mapActions('campaigns', ['toggleFormEditCampaign'])
  }
}
</script>

<style lang="scss" scoped>
.box-campaign {
  padding:16px 0 12px;
  margin-bottom: 0;
  border:1px solid #eaeaea;
  border-radius: 4px;
  position: relative;

  &:hover {
    .tag.button {
      opacity: 1;
    }
  }
  p.informations {
    > .item {
      font-size: 13px;
      height: 16px;
      border-radius: 4px;
      overflow: hidden;
      border:1px solid #dadada;
      padding: 4px;
      text-align: center;
      .value, .text {
        display: inline-block;
        height: 100%;
        border-radius: 0;
        padding: 0 6px 0 2px;
      }
      .text {
        padding: 0 2px 0 6px;
        border-left:1px solid #dadada;
      }
      margin-right: 4px;
    }
  }
}

.box-campaign {
  position: relative;
}

.box-title {
  margin-bottom: 8px;
}

.group-actions-campaign {
  > button {
    text-transform: inherit
  }
  float: right;
}

h2.title {
  cursor: pointer;
}

.campaign-header {
  padding:0 24px;
  display: grid;
  grid-template-columns: 1fr 40px;
  grid-template-areas:
    "title actions"
    ;
    align-items: center;
  > h2.title {
    grid-area: title;
  }
  > div.actions {
    grid-area: actions;
    > div {
      float: right;
    }
  }

  .period {
    margin-top:12px;
    display: inline-block;
    color: #868686;
    font-weight: 600;
  }
  .tag.button {
    transition: opacity 600ms ease;
    opacity: 0.3;
    border:1px solid #aeaeae;
    color:#aeaeae;
    cursor: pointer;
  }
}

.nb-details-badges {
  margin-top: 10px;
  .tag {
    font-weight: 600;
    text-transform: lowercase;
    font-size: 12px;
    margin-right: 8px;
  }
}

.badge-list-empty {
  margin: 12px 0;
}
.add-badge-prompt {
  width: 100%;
  display: block;
  background: #F5D76E;
  color: #434343;
  text-align: center;
  font-size: 1.2em;
  padding: 2em;
  font-weight: bold;
  cursor: pointer;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/campaigns/campaign.vue